export default "__VITE_ASSET__Bt4Im_dg__"